<template>
    <div class="header">
      <div class="logo">
        <img src="@/assets/logo.png" alt="logo" class="logo-img" />安徽理工大学人工智能学院 会议室预约管理系统</div>
      <div class="nav">
        <router-link to="/">首页</router-link>
        <router-link to="/manage">预约管理</router-link>
        <router-link to="/statistics">使用统计</router-link>
<!--        <router-link to="/userManage" v-if="isAdmin">用户管理</router-link>-->
        <el-dropdown v-if="isAdmin" @command="handleCommand">
          <div class="nav">
          <span class="el-dropdown-link" style="color: white;font-size: 16px">系统管理</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="/userManage">用户管理</el-dropdown-item>
            <el-dropdown-item divided command="/roomManage">会议室管理</el-dropdown-item>
          </el-dropdown-menu>
          </div>
        </el-dropdown>


        <el-dropdown class="avatar-container" trigger="hover">
  <span class="el-dropdown-link" style="color: white; cursor: pointer;">
    <template>{{ getTimeStatus() + name }}</template>
    <el-icon class="el-icon--right">
      <arrow-down />
    </el-icon>
    <span style="font-size: 12px; opacity: 0.8; margin-left: 5px;">▼</span>
  </span>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <el-dropdown-item divided @click.native="handleLogout">
              <span style="display:block;">用户注销</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </template>

  <script>
  import { mapGetters } from 'vuex'
  import {logout} from '@/api/user'
  export default {
    name: 'Header',
    data() {
      return {
        userBlobUrl: '',
        time:''
      }
    },
    computed: {
      ...mapGetters(['role','name']),
      isAdmin() {
        return this.role === 'admin'
      }
    },
    methods: {
      async handleLogout(){
        // console.log("2222")
        await this.$store.dispatch('user/logout');
        this.$router.push({ path: '/login' });
      },
      handleCommand(path) {
        this.$router.push(path).catch(() => {});
      },
      // 获取时间状态
      getTimeStatus(){
        const now = new Date()
        const hour = now.getHours()

        if (hour >= 0 && hour < 6) {
          return '凌晨好，'
        } else if (hour >= 6 && hour < 12) {
          return '上午好，'
        } else if (hour >= 12 && hour < 18) {
          return '下午好，'
        } else {
          return '晚上好，'
        }
      }
    }
  }

  </script>

  <style lang="scss" scoped>
  .header {
    background-color: #80c1fa;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 60px;
  }

  .logo {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
  }

  .logo-img {
    height: 40px; /* 调整高度 */
    margin-right: 10px; /* 图片和文字的间距 */
  }

  .nav {
    display: flex;
    gap: 20px;
    align-items: center;
  }

  .nav a,
  .nav-link {
    color: white;
    text-decoration: none;
    padding: 5px 10px;
    border-radius: 4px;
    transition: background-color 0.3s;
    cursor: pointer;
  }
  .dropdown-link {
    color: #606266;
    text-decoration: none;
    display: block;
    width: 100%;
    height: 100%;
  }

  .nav a:hover,
  .nav a.router-link-active,
  .nav-link:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  .system-container{
    margin-top: 2px;
    color: white;
    text-decoration: none;
    padding: 5px 10px;
    border-radius: 4px;
    transition: background-color 0.3s;
  }
  .avatar-container {
    margin-right: 30px;

    .avatar-wrapper {
       margin-top: 5px;
      position: relative;

      .user-avatar {
        cursor: pointer;
        margin: 9px;
        width: 25px;
        height: 25px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: 2px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
  .example-showcase .el-dropdown-link {
    height: 36px;
    width: 56px;
    cursor: pointer;
    color: white;
    display: flex;
    align-items: center;
  }


</style>





